import { atom } from 'nanostores';
import { CustomerWithContacts, Transaction } from './database/schema';
import { InvoicesHistoryData } from './types';

export const $transactions = atom<{ isLoad: boolean, values: Transaction[] }>({ isLoad: false, values: [] });
export const $invoices = atom<{ isLoad: boolean, values: InvoicesHistoryData[] }>({ isLoad: false, values: [] });
export const $customers = atom<{ isLoad: boolean, values: CustomerWithContacts[] }>({ isLoad: false, values: [] });
export const $archivedCustomers = atom<{ isLoad: boolean, values: CustomerWithContacts[] }>({ isLoad: false, values: [] });
export const $archivedInvoices = atom<{ isLoad: boolean, values: InvoicesHistoryData[] }>({ isLoad: false, values: [] });
export const $blockRowNavigate = atom<boolean>(false);